import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Pedidos")
], -1)
const _hoisted_3 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 align-items-center ms-md-auto"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = { class: "table-responsive p-0" }
const _hoisted_8 = { class: "table align-items-center mb-0" }
const _hoisted_9 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Loja ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-1" }, "Alocada", -1)
const _hoisted_15 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Cupom Fiscal")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Embalagens", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Veículo ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Janela Entrega ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Finalizado", -1)
const _hoisted_21 = { class: "d-flex px-2 py-1" }
const _hoisted_22 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_23 = { class: "mb-0 text-sm" }
const _hoisted_24 = { class: "text-xs text-secondary mb-0" }
const _hoisted_25 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_26 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_27 = { class: "text-center text-uppercase text-secondary text-xxs capacidade" }
const _hoisted_28 = { class: "text-center text-uppercase text-secondary text-xxs cupom" }
const _hoisted_29 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_30 = { class: "tags-container-romaneio" }
const _hoisted_31 = { class: "text-sm justify-content-center flex-column" }
const _hoisted_32 = { class: "text-sm justify-content-center flex-column" }
const _hoisted_33 = {
  key: 0,
  class: "d-flex flex-column badge badge-sm bg-gradient-primary"
}
const _hoisted_34 = {
  key: 1,
  class: "d-flex flex-column badge badge-sm bg-gradient-danger"
}
const _hoisted_35 = {
  key: 2,
  class: "d-flex flex-column badge badge-sm bg-gradient-manual"
}
const _hoisted_36 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "text-uppercase text-secondary text-sm font-weight-bolder" }
const _hoisted_44 = { class: "form-check form-switch" }
const _hoisted_45 = ["onChange", "onUpdate:modelValue"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label text-danger",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_53 = [
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.searchItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                placeholder: "Procurar..."
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_9, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('numero_pedido')
                }, null, 8, _hoisted_10),
                _hoisted_11,
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortData('numero_pedido')))
                }, " Pedido "),
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData('numero_pedido'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _createElementVNode("th", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-1"
              }, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('id_operacao')
                }, null, 8, _hoisted_12),
                _hoisted_13,
                _createElementVNode("i", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchData('id_operacao'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _hoisted_14,
              _createElementVNode("th", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("i", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchData('cupom_fiscal'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _hoisted_17,
              _createElementVNode("th", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortData('tipo'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Tipo"),
              _createElementVNode("th", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Status"),
              _hoisted_18,
              _hoisted_19,
              _hoisted_20
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (pedido) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h6", _hoisted_23, _toDisplayString(pedido.numero_pedido), 1),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(pedido.brand), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(pedido.id_operacao), 1)
                ]),
                _createElementVNode("td", _hoisted_27, _toDisplayString(pedido.capacidade || 0), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(pedido.cupom_fiscal || "-"), 1),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedido.embalagens, (tag, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag-romaneio"
                      }, _toDisplayString(tag.codigo_embalagem), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("span", {
                    class: _normalizeClass(`d-flex flex-column badge badge-sm bg-${pedido.tipo=='entrega'?'success':'info'}`)
                  }, _toDisplayString(pedido.tipo), 3)
                ]),
                _createElementVNode("td", _hoisted_32, [
                  (pedido.id_rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "ALOCADO"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_34, "sem rota")),
                  (pedido.manual)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "MANUAL"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_36, [
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(pedido.rota.veiculo.modelo), 1))
                    : _createCommentVNode("", true),
                  _hoisted_38,
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(pedido.rota.veiculo.marca), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("div", null, [
                    (!pedido.editInicio)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.fDate(pedido.janela_entrega_inicio)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (!pedido.editFim)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.fDate(pedido.janela_entrega_fim)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input form-check-custom",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => (_ctx.doUpdate({}, pedido)),
                      "onUpdate:modelValue": ($event: any) => ((pedido.finalizado) = $event)
                    }, null, 40, _hoisted_45), [
                      [_vModelCheckbox, pedido.finalizado]
                    ]),
                    _hoisted_46
                  ]),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.gotoPedido(pedido)),
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_49, 8, _hoisted_47),
                  _hoisted_50,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.removePedido(pedido)),
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_53, 8, _hoisted_51)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}